import _ from "lodash";
import React from "react";
import moment from "moment";
import { styles } from "Tooling/commonStyles";
import {
  CURRICULUM_TYPE_DP,
  CURRICULUM_TYPE_PYP,
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_UBD,
  CURRICULUM_VARIANT_CGC,
  CURRICULUM_VARIANT_CAMBRIDGE,
  CURRICULUM_VARIANT_TODDLE_PLAY,
  CURRICULUM_VARIANT_AUSC,
  CURRICULUM_VARIANT_OPEN,
  CURRICULUM_VARIANT_WACE,
  CURRICULUM_VARIANT_WAC_K10,
  MICROSOFT_SERVICE_TYPE,
  GOOGLE_SERVICE_TYPE,
  CURRICULUM_VARIANT_ENC,
  CURRICULUM_VARIANT_ENC_GCSE,
  CURRICULUM_VARIANT_ENC_ALEVEL,
  COURSE_BASED_GRADING,
  SUBJECT_BASED_GRADING,
  IB_PROGRAMS,
} from "Constants/stringConstants";
import {
  USER_TYPES,
  ROLE_TYPES,
  CURRICULUM_PLANS,
  CURRICULUM_PROGRAM_TYPES,
} from "Constants";
import { getDefaultAcademicYears } from "Tooling/modules/ToolingModule";
import { getOrganizationFeedDetailsFromCache } from "Tooling/modules/ToolingGraphqlHelpers";
import ACLStore from "lib/aclStore";
import { ALLOW_MULTIPLE_PROGRAM_LANGUAGES_IN_NON_DP_PROGRAMS } from "Constants/permissionConstants";
import { getSettingValue } from "Utils/ConfigurationUtils";

const {
  feedListItemStyle,
  feedListJustifyStartStyle,
  feedListJustifyCenterStyle,
  feedListTextAlignCenterStyle,
} = styles;

export const CURRICULUM_PLANS_OPTIONS = [
  { key: "", label: "All" },
  { key: "6", label: "Demo" },
  { key: "1", label: "Free" },
  { key: "2", label: "Pro" },
  { key: "4", label: "360" },
  { key: "3", label: "Pro Pilot" },
  { key: "5", label: "360 Pilot" },
];

export const GENERIC_CONFIGURATION_COLUMNS = [
  {
    label: "",
    id: "deprecatedAlert",
    type: "CUSTOM",
    isSticky: true,
    visible: true,
  },
  {
    label: "Id",
    id: "id",
    type: "INTCOLUMN",
    isSticky: true,
    sortType: "toggle",
    entity: "ID",
    visible: true,
  },
  {
    label: "Configuration",
    id: "configuration",
    type: "TEXTCOLUMN",
    isSticky: true,
    sortType: "toggle",
    entity: "CONFIGURATION",
    style: { maxWidth: "300px" },
    visible: true,
  },
  {
    label: "Group",
    id: "configurationGroup",
    type: "TEXTCOLUMN",
    sortType: "toggle",
    entity: "CONFIGURATION_GROUP",
    visible: true,
  },
  {
    label: "Control parameter type",
    id: "aclControlParameterType",
    type: "TEXTCOLUMN",
    visible: true,
  },
  {
    label: "Description",
    id: "description",
    type: "TEXTCOLUMN",
    style: { width: "300px" },
    visible: true,
  },
  {
    label: "Modules",
    id: "aclModules",
    type: "ARRAYCOLUMNWITHOVER",
    visible: true,
    arrayColumnNoItemsText: "-",
  },
  {
    label: "Applicable portals",
    id: "aclPortalTypes",
    type: "ARRAYCOLUMNWITHOVER",
    visible: true,
    arrayColumnNoItemsText: "-",
  },
  {
    label: "Dependent entities",
    id: "entities",
    type: "ARRAYCOLUMNWITHOVER",
    visible: true,
  },
  {
    label: "Owner Team",
    id: "ownerTeam",
    type: "TEXTCOLUMN",
    visible: true,
  },
  {
    label: "Actions",
    id: "actions",
    type: "ACTIONS",
    visible: true,
  },
].filter(item => item.visible);

export const IS_PAID_ORGANIZATION_OPTIONS = [
  { key: "", label: "All" },
  { key: "0", label: "Non-Paid", value: false },
  { key: "1", label: "Paid", value: true },
];

export const BULK_ENABLE_CONFIGURATIONS_COLUMNS = [
  {
    label: "Id",
    id: "id",
    type: "INTCOLUMN",
    isSticky: true,
  },
  {
    label: "Configuration",
    id: "configuration",
    type: "TEXTCOLUMN",
    isSticky: true,
  },
  { label: "Default Value", id: "defaultConfigurationValue", type: "CUSTOM" },
];

export const MULTI_PROGRAM_DATA_LANGUAGE_ENABLED_CURRICULUMS = [
  CURRICULUM_TYPE_DP,
  CURRICULUM_TYPE_MYP,
];

export const TODDLE_VERSIONS = [
  {
    label: "All",
    key: "",
  },
  {
    label: "Toddle 1.0",
    key: "TODDLE_1_0",
    value: "TODDLE_1_0",
  },
  {
    label: "Toddle 2.0",
    key: "TODDLE_2_0",
    value: "TODDLE_2_0",
  },
];

export const getConfigurationsFilters = ({
  searchText,
  sortedFieldsWithOrder,
  feedFilters,
}) => {
  const order = _.head(_.values(sortedFieldsWithOrder));
  const { direction, menuItemEntity } = order;
  return {
    searchText,
    orderBy: menuItemEntity || "ID",
    orderByDirection: direction || "ASC",
    first: 20,
    ...feedFilters,
  };
};

export const getGenericConfigurationActionItems = ({
  openActionModal,
  onEditClick,
  onDownloadDMLClick,
  onCreateMigrationPRClick,
  disableWriteAccess,
  disableWriteValueAccess,
  disableWriteAccessInThisRegion,
  isDeleted,
  isDeprecated,
}) =>
  [
    {
      label: "Edit",
      key: "edit",
      visible: !isDeleted,
      disabled: false,
      clickAction: () => onEditClick(),
    },
    {
      label: "Add values",
      key: "add_value",
      visible: !isDeleted,
      disabled: disableWriteAccess && disableWriteValueAccess,
      clickAction: () => openActionModal("ADD_VALUE"),
    },
    {
      label: "View values",
      key: "view_value",
      visible: true,
      clickAction: () => openActionModal("VIEW_VALUES"),
    },
    {
      label: "Download DML file",
      key: "download_dml",
      visible: true,
      clickAction: () => onDownloadDMLClick(),
    },
    {
      label: "Create Migration PR",
      key: "create_migration_pr",
      visible: true,
      clickAction: () => onCreateMigrationPRClick(),
    },
    // {
    //   label: "Manage view",
    //   key: "manage_view",
    //   visible: showManageView && !filters.isDeleted,
    //   clickAction: () => openActionModal("MANAGE_VIEW"),
    // },
    {
      label: isDeleted ? "Restore" : "Delete",
      key: "delete",
      isDestructive: true,
      visible: true,
      disabled: disableWriteAccess || disableWriteAccessInThisRegion,
      clickAction: () => openActionModal("DELETE_CONFIGURATION"),
    },
    {
      label: isDeprecated ? "Activate" : "Deprecate",
      key: "deprecate",
      isDestructive: true,
      visible: true,
      disabled:
        disableWriteAccess || disableWriteAccessInThisRegion || isDeleted,
      clickAction: () => openActionModal("DEPRECATE_CONFIGURATION"),
    },
  ].filter(item => item.visible);

const getLabelValueMap = ({ list }) =>
  _.map(list, value => ({ label: value, value }));

export const getLabelValueMapMemoized = _.memoize(
  params => getLabelValueMap(params),
  params => JSON.stringify(params)
);

export const getConfigurationValuesQueryVariables = ({
  configurationIds,
  searchText,
}) => {
  return {
    filters: {
      configurationIds,
      searchText,
    },
  };
};

export const getEntityTypeOptions = ({
  entityOptions,
  entities,
  dependentEntitiesList,
  entityIdx,
  showAllEntityOptions,
}) => {
  const slicedEntities = _.slice(entities, entityIdx + 1);

  if (_.size(slicedEntities) < 1 || showAllEntityOptions) return entityOptions;

  const selectedEntityTypes = _.map(slicedEntities, "entityType");
  const possibleOptions = [];

  _.forEach(dependentEntitiesList, ({ entityGroup }) => {
    const [selectedOptions, unselectedOptions] = _.partition(
      entityGroup,
      item => _.includes(selectedEntityTypes, item)
    );
    if (_.size(selectedOptions) == _.size(selectedEntityTypes))
      possibleOptions.push(...unselectedOptions);
  });

  return _.filter(entityOptions, ({ value }) =>
    _.includes(possibleOptions, value)
  );
};

export const VALUE_TYPES_LIST = [
  { label: "Boolean", value: "BOOLEAN" },
  { label: "Number", value: "NUMBER" },
  { label: "Array", value: "ARRAY" },
  { label: "JSON", value: "JSON" },
  { label: "Text", value: "TEXT" },
];

export const RELATIONSHIP_OPTIONS = [
  { label: "Parent", value: "PARENT" },
  { label: "Child", value: "CHILD" },
];

export const getEntityValueOptions = ({
  entityType,
  supportedAppTypesList,
}) => {
  switch (entityType) {
    case "USER_TYPE":
      return USER_TYPES;
    case "ROLE":
      return ROLE_TYPES;
    case "PLAN":
      return CURRICULUM_PLANS;
    case "APP_TYPE":
      return supportedAppTypesList;
    case "CURRICULUM_TYPE":
      return CURRICULUM_PROGRAM_TYPES;
    default:
      return [];
  }
};

export const checkIsValidValue = ({ value, valueType }) => {
  let isValid = true;
  let parsedValue;
  try {
    parsedValue = JSON.parse(value);
  } catch (e) {
    return valueType === "TEXT";
  }
  const type = _.lowerCase(
    Object.prototype.toString.call(parsedValue).slice(8, -1)
  );
  switch (valueType) {
    case "BOOLEAN":
    case "NUMBER":
      isValid = _.upperCase(type) === valueType;
      break;
    case "ARRAY":
      isValid = Array.isArray(parsedValue);
      break;
    case "JSON":
      isValid = type === "object";
      break;
  }
  return isValid;
};

export const checkAddValueFormIsValid = ({
  addValueDetails,
  valueType,
  isNewConfigurationFlowEnabled,
}) => {
  const { settingValue, entityGroups, region } = addValueDetails;
  const errorText = "Please fill all fields";
  if (
    _.isEmpty(settingValue) ||
    _.isEmpty(entityGroups) ||
    (isNewConfigurationFlowEnabled && !region)
  ) {
    return errorText;
  }

  const isValueValid = checkIsValidValue({ value: settingValue, valueType });
  if (!isValueValid)
    return "Entered value is not valid for the given value type";

  let error = "";
  _.forEach(entityGroups, ({ entityGroup }) => {
    if (_.isEmpty(entityGroup)) error = errorText;
    _.forEach(entityGroup, ({ entityId }) => {
      if (_.isEmpty(entityId)) error = errorText;
    });
    if (!_.isEmpty(error)) return;
  });
  return error;
};

export const getEntitiesData = ({ list }) =>
  _.map(list, ({ entityGroupId, entities }) => {
    return _.map(entities, ({ entityType, entityId }) => ({
      entityType,
      entityId,
      entityGroupId,
    }));
  });

export const getRelationships = ({ list, type }) =>
  _.reduce(
    list,
    (result, { id, configuration }) => {
      result[id] = {
        ..._.find(RELATIONSHIP_OPTIONS, { value: type }),
        configuration,
        isExisting: true,
      };
      return result;
    },
    {}
  );

export const ALLSCHOOLS_SCHOOL_PAGE_COLUMNS = [
  {
    id: "SCHOOL_DETAILS",
    label: "School name",
    type: "CUSTOM",
    style: {
      ...feedListItemStyle,
      ...feedListJustifyStartStyle,
    },
  },
  {
    id: "TODDLE_BUDDIES",
    label: "Toddle buddies",
    type: "CUSTOM",
    style: {
      ...feedListItemStyle,
      ...feedListJustifyCenterStyle,
    },
  },
  {
    id: "PLAN",
    type: "CUSTOM",
    label: "Plan",
    style: { ...feedListItemStyle, ...feedListJustifyCenterStyle },
  },
  {
    id: "TOTAL_CLASSES",
    type: "INTCOLUMN",
    label: "Total classes",
    style: { ...feedListItemStyle, ...feedListJustifyCenterStyle },
  },
  {
    id: "TOTAL_STAFFS",
    label: "Total staffs",
    type: "INTCOLUMN",
    style: { ...feedListItemStyle, ...feedListJustifyCenterStyle },
  },
  {
    id: "TOTAL_STUDENTS",
    type: "INTCOLUMN",
    label: "Total students",
    style: { ...feedListItemStyle, ...feedListJustifyCenterStyle },
  },
  {
    id: "TAGS",
    label: "Tags",
    type: "CUSTOM",
    style: {
      ...feedListItemStyle,
      ...feedListJustifyCenterStyle,
      ...feedListTextAlignCenterStyle,
    },
  },
  {
    id: "ACTIONS",
    label: "Actions",
    type: "CUSTOM",
    style: { ...feedListItemStyle, ...feedListJustifyCenterStyle },
  },
  {
    id: "SWITCH_ORGANIZATION",
    label: "",
    type: "CUSTOM",
    style: { ...feedListItemStyle, ...feedListJustifyCenterStyle },
  },
];

export const TRANSITION_SCHOOL_PAGE_COLUMNS = [
  {
    id: "SCHOOL_DETAILS",
    label: "School name",
    type: "CUSTOM",
    style: {
      ...feedListItemStyle,
      ...feedListJustifyStartStyle,
    },
  },
  {
    id: "TODDLE_BUDDIES",
    label: "Toddle buddies",
    type: "CUSTOM",
    style: {
      ...feedListItemStyle,
      ...feedListJustifyCenterStyle,
    },
  },
  {
    id: "PROGRAMS",
    label: "Programs",
    type: "CUSTOM",
    style: {
      ...feedListItemStyle,
      ...feedListJustifyCenterStyle,
    },
  },
  {
    id: "STATUS",
    label: "Status",
    type: "CUSTOM",
    style: {
      ...feedListItemStyle,
      ...feedListJustifyCenterStyle,
    },
  },
  {
    id: "TAGS",
    label: "Tags",
    type: "CUSTOM",
    style: {
      ...feedListItemStyle,
      ...feedListJustifyCenterStyle,
      ...feedListTextAlignCenterStyle,
    },
  },
  {
    id: "ACTIONS",
    label: "Actions",
    type: "CUSTOM",
    style: { ...feedListItemStyle, ...feedListJustifyCenterStyle },
  },
  {
    id: "SWITCH_ORGANIZATION",
    label: "",
    type: "CUSTOM",
    style: { ...feedListItemStyle, ...feedListJustifyCenterStyle },
  },
];

export const MANAGE_PROGRAMMES_PAGE_COLUMNS = [
  {
    id: "ACTIONS",
    label: "",
    type: "CUSTOM",
    style: {
      verticalAlign: "top",
      paddingTop: "8px",
      paddingLeft: "4px",
      paddingRight: "4px",
    },
  },
  {
    id: "SCHOOL_DETAILS",
    label: "School name",
    type: "CUSTOM",
    style: {
      ...feedListItemStyle,
      verticalAlign: "baseline",
      paddingLeft: "4px",
      paddingTop: "8px",
      width: "400px",
    },
  },
  {
    id: "PROGRAMS",
    type: "MULTIROW",
    subType: "CUSTOM",
    label: "Programme",
    style: {
      width: "100px",
      paddingRight: "4px",
    },
    singleRowStyle: {
      fontSize: "14px",
    },
  },
  {
    id: "PLANNING_SETUP",
    type: "MULTIROW",
    subType: "CUSTOM",
    label: "Planning Setup",
    style: {
      paddingRight: "4px",
    },
    singleRowStyle: {
      fontSize: "14px",
    },
  },
  {
    id: "GRADING_SETUP",
    type: "MULTIROW",
    subType: "CUSTOM",
    label: "Grading Setup",
    style: {
      paddingRight: "4px",
    },
    singleRowStyle: {
      fontSize: "14px",
    },
  },
  {
    id: "USERS",
    type: "MULTIROW",
    subType: "CUSTOM",
    label: "Users",
    style: {
      width: "100px",
      paddingRight: "4px",
      paddingLeft: "4px",
    },
  },
  {
    id: "PLAN",
    type: "MULTIROW",
    subType: "CUSTOM",
    label: "Plan",
    style: {
      width: "140px",
      paddingLeft: "4px",
      paddingRight: "20px",
    },
    singleRowStyle: {
      paddingLeft: "4px",
    },
  },
  {
    id: "SUBSCRIPTION_PLAN",
    type: "MULTIROW",
    subType: "CUSTOM",
    label: "Subscription plan",
    style: {
      paddingLeft: "20px",
      paddingRight: "2px",
    },
    singleRowStyle: {
      paddingLeft: "20px",
    },
  },
  {
    id: "INFO_MODAL",
    label: "",
    type: "MULTIROW",
    subType: "CUSTOM",
    alignment: "center",
    style: {
      ...feedListItemStyle,
      ...feedListJustifyCenterStyle,
    },
  },
];

const betaTagStyle = {
  fontSize: "1.2rem",
  fontWeight: "bold",
  verticalAlign: "super",
};

const getVariantLabelElement = ({ label }) => {
  return (
    <span>
      {`${label} `}
      <span style={betaTagStyle}>Beta</span>
    </span>
  );
};

export const CURRICULUM_FLAVOURS = [
  {
    label: "IB PYP Curriculum",
    value: CURRICULUM_TYPE_PYP,
  },
  {
    label: "IB MYP Curriculum",
    value: CURRICULUM_TYPE_MYP,
  },
  {
    label: "IB DP Curriculum",
    value: CURRICULUM_TYPE_DP,
  },
  {
    label: "Non IB Curriculum (UBD, CGC, Cambridge, etc.)",
    value: CURRICULUM_TYPE_UBD,
  },
];

export const CURRICULUM_PROGRAMS = [
  {
    label: "Primary Years Programme (PYP)",
    value: CURRICULUM_TYPE_PYP,
    type: CURRICULUM_TYPE_PYP,
  },
  {
    label: "Middle Years Programme (MYP)",
    value: CURRICULUM_TYPE_MYP,
    type: CURRICULUM_TYPE_MYP,
  },
  {
    label: "Understanding by Design (UbD)",
    value: CURRICULUM_TYPE_UBD,
    type: CURRICULUM_TYPE_UBD,
  },
  {
    label: "Diploma and/or Career related programme",
    value: CURRICULUM_TYPE_DP,
    type: CURRICULUM_TYPE_DP,
  },
  {
    label: getVariantLabelElement({
      label: "Common Ground Collaborative (CGC)",
    }),
    normalisedLabel: "Common Ground Collaborative (CGC)",
    value: CURRICULUM_VARIANT_CGC,
    variant: CURRICULUM_VARIANT_CGC,
    type: CURRICULUM_TYPE_UBD,
  },
  {
    label: "English National curriculum (ENC)",
    value: CURRICULUM_VARIANT_ENC,
    variant: CURRICULUM_VARIANT_ENC,
    type: CURRICULUM_TYPE_UBD,
  },
  {
    label:
      "English National curriculum - General Certificate of Secondary Education (ENC - GCSE)",
    value: CURRICULUM_VARIANT_ENC_GCSE,
    variant: CURRICULUM_VARIANT_ENC_GCSE,
    type: CURRICULUM_TYPE_UBD,
  },
  {
    label: "English National curriculum - Advanced level(ENC - A level)",
    value: CURRICULUM_VARIANT_ENC_ALEVEL,
    variant: CURRICULUM_VARIANT_ENC_ALEVEL,
    type: CURRICULUM_TYPE_UBD,
  },
  {
    label: getVariantLabelElement({ label: "Cambridge IGCSE (CAMB)" }),
    normalisedLabel: "Cambridge IGCSE (CAMB)",
    value: CURRICULUM_VARIANT_CAMBRIDGE,
    variant: CURRICULUM_VARIANT_CAMBRIDGE,
    type: CURRICULUM_TYPE_UBD,
  },
  {
    label: getVariantLabelElement({ label: "Toddle Play (PLAY)" }),
    normalisedLabel: "Toddle Play (PLAY)",
    value: CURRICULUM_VARIANT_TODDLE_PLAY,
    variant: CURRICULUM_VARIANT_TODDLE_PLAY,
    type: CURRICULUM_TYPE_UBD,
  },
  {
    label: getVariantLabelElement({
      label: "Australian Curriculum Program (AusC)",
    }),
    normalisedLabel: "Australian Curriculum Program (AusC)",
    value: CURRICULUM_VARIANT_AUSC,
    variant: CURRICULUM_VARIANT_AUSC,
    type: CURRICULUM_TYPE_UBD,
  },
  {
    label: getVariantLabelElement({
      label: "Western Australian Curriculum - K-10",
    }),
    normalisedLabel: "Western Australian Curriculum - K-10",
    value: CURRICULUM_VARIANT_WAC_K10,
    variant: CURRICULUM_VARIANT_WAC_K10,
    type: CURRICULUM_TYPE_UBD,
  },
  {
    label: getVariantLabelElement({
      label: "Western Australian Certificate of Education",
    }),
    normalisedLabel: "Western Australian Certificate of Education",
    value: CURRICULUM_VARIANT_WACE,
    variant: CURRICULUM_VARIANT_WACE,
    type: CURRICULUM_TYPE_UBD,
  },
  {
    label: getVariantLabelElement({
      label: "Independent Curriculum Programme (INDP)",
    }),
    normalisedLabel: "Independent Curriculum Programme (INDP)",
    subtitle:
      "Use this program for extensive customization needs not met by other programs",
    value: CURRICULUM_VARIANT_OPEN,
    variant: CURRICULUM_VARIANT_OPEN,
    type: CURRICULUM_TYPE_UBD,
  },
];

export const CURRICULUM_PROGRAMS_FOR_TODDLE_2 = [
  {
    label: "Primary Years Programme (PYP)",
    value: CURRICULUM_TYPE_PYP,
    type: CURRICULUM_TYPE_PYP,
    academicSetupType: SUBJECT_BASED_GRADING,
  },
  {
    label: "Middle Years Programme (MYP)",
    value: CURRICULUM_TYPE_MYP,
    type: CURRICULUM_TYPE_MYP,
    academicSetupType: SUBJECT_BASED_GRADING,
  },
  {
    label: "Diploma Programme (DP)",
    value: CURRICULUM_TYPE_DP,
    type: CURRICULUM_TYPE_DP,
    academicSetupType: SUBJECT_BASED_GRADING,
  },
  {
    label: "Understanding by Design (UbD)",
    value: CURRICULUM_TYPE_UBD,
    type: CURRICULUM_TYPE_UBD,
  },
  {
    label: "Common Ground Collaborative (CGC)",
    value: CURRICULUM_VARIANT_CGC,
    variant: CURRICULUM_VARIANT_CGC,
    type: CURRICULUM_TYPE_UBD,
  },
  {
    label: "English National curriculum (ENC)",
    value: CURRICULUM_VARIANT_ENC,
    variant: CURRICULUM_VARIANT_ENC,
    type: CURRICULUM_TYPE_UBD,
  },
  {
    label:
      "English National curriculum - General Certificate of Secondary Education (ENC - GCSE)",
    value: CURRICULUM_VARIANT_ENC_GCSE,
    variant: CURRICULUM_VARIANT_ENC_GCSE,
    type: CURRICULUM_TYPE_UBD,
  },
  {
    label: "English National curriculum - Advanced level(ENC - A level)",
    value: CURRICULUM_VARIANT_ENC_ALEVEL,
    variant: CURRICULUM_VARIANT_ENC_ALEVEL,
    type: CURRICULUM_TYPE_UBD,
  },
  {
    label: "Cambridge IGCSE (CAMB)",
    value: CURRICULUM_VARIANT_CAMBRIDGE,
    variant: CURRICULUM_VARIANT_CAMBRIDGE,
    type: CURRICULUM_TYPE_UBD,
  },
  {
    label: "Toddle Play (PLAY)",
    value: CURRICULUM_VARIANT_TODDLE_PLAY,
    variant: CURRICULUM_VARIANT_TODDLE_PLAY,
    type: CURRICULUM_TYPE_UBD,
  },
  {
    label: "Australian Curriculum Program (AusC)",
    value: CURRICULUM_VARIANT_AUSC,
    variant: CURRICULUM_VARIANT_AUSC,
    type: CURRICULUM_TYPE_UBD,
  },
  {
    label: "Western Australian Curriculum - K-10",
    value: CURRICULUM_VARIANT_WAC_K10,
    variant: CURRICULUM_VARIANT_WAC_K10,
    type: CURRICULUM_TYPE_UBD,
  },
  {
    label: "Western Australian Certificate of Education",
    value: CURRICULUM_VARIANT_WACE,
    variant: CURRICULUM_VARIANT_WACE,
    type: CURRICULUM_TYPE_UBD,
  },
  {
    label: "Independent Curriculum Programme (INDP)",
    subtitle:
      "Use this program for extensive customization needs not met by other programs",
    value: CURRICULUM_VARIANT_OPEN,
    variant: CURRICULUM_VARIANT_OPEN,
    type: CURRICULUM_TYPE_UBD,
  },
];

export const UBD_CURRICULUM_VARIANTS = [
  CURRICULUM_VARIANT_CGC,
  CURRICULUM_VARIANT_CAMBRIDGE,
  CURRICULUM_VARIANT_TODDLE_PLAY,
  CURRICULUM_VARIANT_AUSC,
  CURRICULUM_VARIANT_OPEN,
  CURRICULUM_VARIANT_ENC,
  CURRICULUM_VARIANT_ENC_GCSE,
  CURRICULUM_VARIANT_ENC_ALEVEL,
  CURRICULUM_VARIANT_WAC_K10,
  CURRICULUM_VARIANT_WACE,
];

export const ALLOWED_TOOLS_BY_REGION = {
  ["TOOL_EU_WEST_1"]: ["USERS", "CONFIGURATIONS"],
  ["TOOL_US_EAST_1"]: ["USERS", "CONFIGURATIONS"],
  ["TOOL_ME_CENTRAL_1"]: ["USERS", "CONFIGURATIONS"],
  ["TOOL_EU_CENTRAL_1"]: ["USERS", "CONFIGURATIONS"],
  ["TOOL_AP_SOUTHEAST_2"]: ["USERS", "CONFIGURATIONS"],
  ["TOOL_AP_SOUTHEAST_1"]: ["USERS", "CONFIGURATIONS"],
  ["TOOL_CN_NORTH_1"]: ["USERS", "CONFIGURATIONS"],
  ["COMMON"]: [
    "TEMPLATE-EDITOR",
    "INTERNAL-TOOLS",
    "ORGANIZATION-APPROVAL",
    "STANDARDS",
    "PR-TEMPLATE-EDITOR",
  ],
};

export const getCreateOrgDetails = () => {
  const orgDetails = {
    academicYears: getDefaultAcademicYears(),
    schedulerStartTime: moment("08:00", "HH:mm"),
    schedulerEndTime: moment("15:00", "H:mm"),
    schedulerStartDay: 1,
    locale: "en",
    schedulerWeekLength: 5,
    rosteringMethod: "",
    operationalDays: [1, 2, 3, 4, 5],
    examSessionMonth: null,
  };

  return orgDetails;
};
const getCurriculumOptions = curriculumPrograms => {
  return _.map(
    curriculumPrograms,
    ({
      buddy,
      subscriptionPlan,
      type,
      label,
      acronym,
      id,
      programDataLanguages,
      variant,
      dealId,
      students,
      platformId,
      tags,
      curriculumProgramData,
      examSessionMonth,
    }) => ({
      variant,
      curriculumType: type,
      planId: _.get(subscriptionPlan, "id", ""),
      toddleBuddyId: _.get(buddy, "id", ""),
      gradesToBeIncluded: [],
      id,
      label,
      acronym,
      dealId,
      platformId,
      tags,
      examSessionMonth,
      studentCount: _.get(students, "totalCount", 0),
      curriculumProgramData,
      ...(ACLStore.can(ALLOW_MULTIPLE_PROGRAM_LANGUAGES_IN_NON_DP_PROGRAMS) ||
      _.includes(MULTI_PROGRAM_DATA_LANGUAGE_ENABLED_CURRICULUMS, type)
        ? { programDataLanguages }
        : {}),
    })
  );
};

const getCurriculumOptionsV2 = curriculumPrograms => {
  return _.map(
    curriculumPrograms,
    ({
      buddy,
      subscriptionPlan,
      type,
      label,
      acronym,
      id,
      programDataLanguages,
      defaultLanguage,
      variant,
      dealId,
      platformId,
      tags,
      curriculumProgramData,
      programType,
      academicSetupType,
      accountProgram,
      students,
      academicProgram,
      examSessionMonth,
      isFeatureFlagLearningCoursesEnabled,
    }) => ({
      variant,
      curriculumType: type,
      planId: _.get(subscriptionPlan, "id", ""),
      toddleBuddy: _.get(buddy, "id", ""),
      grades: [],
      id,
      label,
      acronym,
      dealId,
      platformId,
      tags,
      curriculumProgramData,
      programType,
      examSessionMonth,
      defaultLanguage,
      studentCount: _.get(students, "totalCount", 0),
      isFeatureFlagLearningCoursesEnabled,
      ...(academicSetupType && { academicSetupType }),
      ...(academicProgram && {
        academicProgramId: _.get(academicProgram, "id", ""),
      }),
      ...(accountProgram && {
        accountProgramId: _.get(accountProgram, "id", ""),
      }),
      ...(ACLStore.can(ALLOW_MULTIPLE_PROGRAM_LANGUAGES_IN_NON_DP_PROGRAMS) ||
      _.includes(MULTI_PROGRAM_DATA_LANGUAGE_ENABLED_CURRICULUMS, type)
        ? { language: programDataLanguages }
        : { language: _.get(programDataLanguages, "[0]", "") }),
    })
  );
};

export const getOrganizationDetails = ({
  organizationFeedDetails,
  organizationAdditionalDetails,
  isToddle2Organization,
}) => {
  const orgDetails = _.merge(
    {},
    organizationFeedDetails,
    organizationAdditionalDetails
  );
  const curriculumPrograms = _.get(orgDetails, "curriculumPrograms", []);

  const curriculumOptions = isToddle2Organization
    ? getCurriculumOptionsV2(curriculumPrograms)
    : getCurriculumOptions(curriculumPrograms);

  const rosteringMethod = _.get(
    _.head(curriculumPrograms),
    "rosteringMethod",
    ""
  );

  const locale = getSettingValue({ name: "locale" }) || "en";
  const globalConstants = _.get(orgDetails, "globalConstants", null);
  const timezone = _.get(
    _.find(globalConstants, ({ name }) => name === "TIMEZONE"),
    "value",
    null
  );
  const storageType = JSON.parse(
    _.get(
      _.find(
        globalConstants,
        ({ name }) => name === "THIRD_PARTY_SERVICE_TYPE_PREFERENCE"
      ),
      "value",
      null
    )
  );
  const examSessionTimezone = _.get(
    _.find(globalConstants, ({ name }) => name === "EXAM_SESSION_TIMEZONE"),
    "value",
    null
  );

  const organizationDetails = {
    ..._.pick(orgDetails, [
      "id",
      "name",
      "code",
      "toddleBuddy",
      "attachments",
      "academicYears",
      "region",
    ]),
    planId: _.get(orgDetails, "tier.id"),
    schedulerStartTime: moment(
      _.get(orgDetails, "constants.scheduler.start_time_for_slot"),
      "HH:mm"
    ),
    schedulerEndTime: moment(
      _.get(orgDetails, "constants.scheduler.end_time_for_slot"),
      "HH:mm"
    ),
    schedulerStartDay: _.get(orgDetails, "constants.scheduler.week_start_day"),
    schedulerWeekLength: _.get(orgDetails, "constants.scheduler.week_length"),
    examSessionMonth: _.get(orgDetails, "constants.examSessionMonth", null),
    locale,
    curriculumOptions,
    rosteringMethod,
    examSessionTimezone,
    ...(timezone && { timezone }),
    ...(storageType && { storageType: storageType[0] }),
  };
  return organizationDetails;
};

export const getOrganizationDetailsByMode = ({ mode, organizationId }) => {
  switch (mode) {
    case "editBasicDetails": {
      return getOrganizationFeedDetailsFromCache({
        organizationId,
      });
    }
    case "create": {
      return getCreateOrgDetails();
    }
  }
};

export const REPLICATION_ENABLED_ENTITY_TYPES = [
  "USER_TYPE",
  "ROLE",
  "PLAN",
  "APP_TYPE",
  "CURRICULUM_TYPE",
  "IDENTITY",
];

export const computeRegionState = entityGroups => {
  const reducedValues = _.map(entityGroups, group => {
    const entityTypes = _.map(group.entityGroup, "entityType");
    const isReplicationEnabledForAllEntities = _.every(entityTypes, type =>
      _.includes(REPLICATION_ENABLED_ENTITY_TYPES, type)
    );
    return !isReplicationEnabledForAllEntities;
  });
  let isReplicationEnabled = false;
  let disableSelectRegion = false;
  if (
    _.every(reducedValues, val => val === false) &&
    _.size(reducedValues) > 0
  ) {
    isReplicationEnabled = true;
  } else if (_.every(reducedValues, val => val === true)) {
    disableSelectRegion = false;
    isReplicationEnabled = false;
  } else {
    disableSelectRegion = true;
  }
  return { isReplicationEnabled, disableSelectRegion };
};

export const getToastMsg = (stateToToggle, restoreState) => {
  if (stateToToggle == "DELETE") {
    return restoreState
      ? "Configuration restored successfully"
      : "Successfully deleted";
  } else {
    return restoreState
      ? "Configuration activated successfully"
      : "Successfully deprecated";
  }
};

export const getFilteredPermissionRequestAndCount = organizations => {
  const permissionRequestList = _.get(organizations, "edges", []);
  const totalRequestsCount = _.get(organizations, "totalCount", 0);
  let deletedOrgs = 0;
  const filteredPermissionList = _.filter(
    permissionRequestList,
    permissionRequest => {
      if (_.isNull(_.get(permissionRequest, "node.organization", null))) {
        deletedOrgs += 1;
        return false;
      }
      return true;
    }
  );
  return {
    permissionRequestList: filteredPermissionList,
    totalRequestsCount: totalRequestsCount - deletedOrgs,
  };
};

export const GOOGLE_DRIVE_STORAGE_OPTION = {
  label: "Google",
  value: GOOGLE_SERVICE_TYPE,
};
export const MICORSOFT_DRIVE_STORAGE_OPTION = {
  label: "Microsoft",
  value: MICROSOFT_SERVICE_TYPE,
};

export const getLocalisedAccountTypes = t => {
  return [
    {
      id: 1,
      label: t("common:course_based_setup"),
      subtitle: t("common:course_based_setup_subtitle"),
      value: COURSE_BASED_GRADING,
    },
    {
      id: 2,
      label: t("common:subject_based_setup"),
      subtitle: t("common:subject_based_setup_subtitle"),
      value: SUBJECT_BASED_GRADING,
    },
  ];
};

export const getLocalisedSetupTypes = t => {
  return [
    {
      id: 1,
      value: COURSE_BASED_GRADING,
      label: t("onBoarding:non_ib_programs_with_academic_type", {
        academicType: t("common:course_based_setup"),
      }),
    },
    {
      id: 2,
      value: SUBJECT_BASED_GRADING,
      label: t("onBoarding:non_ib_programs_with_academic_type", {
        academicType: t("common:subject_based_setup"),
      }),
    },
    {
      id: 3,
      value: IB_PROGRAMS,
      label: t("onBoarding:ib_programs"),
    },
  ];
};

export const addDisplayOrderIndexInPrograms = orgDetails => {
  const curriculumPrograms = _.get(orgDetails, "curriculumOptions", []);

  // 1. Sort programs based on programType
  // ACCOUNT > ACADEMIC > SCHOOL
  const sortedPrograms = _.sortBy(curriculumPrograms, curriculumProgram => {
    const programType = _.get(curriculumProgram, "programType", "");
    if (programType === "ACCOUNT") return 1;
    if (programType === "ACADEMIC") return 2;
    if (programType === "SCHOOL") return 3;
    return 4;
  });

  // 2. Add displayOrder based on the sorted order
  const programsWithDisplayOrder = _.map(
    sortedPrograms,
    (curriculumProgram, index) => {
      return {
        ...curriculumProgram,
        displayOrder: index,
      };
    }
  );

  return {
    ...orgDetails,
    curriculumOptions: programsWithDisplayOrder,
  };
};

export const getAcademicYearsPayloadForAccount = academicYears => {
  if (_.isEmpty(academicYears)) return [];

  return _.map(academicYears, academicYear => ({
    startDate: moment(
      _.get(academicYear, "dateDurationValue.startDate")
    ).format("YYYY-MM-DD"),
    endDate: moment(_.get(academicYear, "dateDurationValue.endDate")).format(
      "YYYY-MM-DD"
    ),
  }));
};

// This function compares the previous and current school details to identify any changes in the plan details. It returns an array of modified school details, including new schools and schools with changed plans.
export const getModifiedSchoolsPlanDetails = ({
  prevSchoolDetails = [],
  currentSchoolsDetails = [],
}) => {
  const prevSchoolsMap = _.keyBy(prevSchoolDetails, "id");

  return _.reduce(
    currentSchoolsDetails,
    (result, { id, subscriptionPlan }) => {
      const prevSchoolDetail = prevSchoolsMap[id];
      const isNewSchool = !prevSchoolDetail;
      const previousPlanId = prevSchoolDetail?.planId || null;
      const currentPlanId = subscriptionPlan?.id;

      if (isNewSchool || previousPlanId !== currentPlanId) {
        result.push({
          id,
          previousPlanId,
          currentPlanId,
          isNewSchool,
          source: "plan_change",
        });
      }

      return result;
    },
    []
  );
};

export const getHasAllSchoolsConnectedToAcademicPrograms = curriculumPrograms => {
  const academicPrograms = _.filter(curriculumPrograms, ({ programType }) => {
    return programType === "ACADEMIC";
  });

  if (_.isEmpty(academicPrograms)) return false;

  const schoolPrograms = _.filter(
    curriculumPrograms,
    ({ programType }) => programType === "SCHOOL"
  );
  if (_.isEmpty(schoolPrograms)) return true;

  return _.every(
    schoolPrograms,
    ({ academicProgram }) => !_.isEmpty(academicProgram)
  );
};
